import { useViewArg } from '../../utils/viewArgs';

export type AuthenticationContext = {
    redirect: string | null;
    redirectConfirmation: boolean;
    authenticated: boolean;
    deviceAuthenticationEnabled: boolean;
    deviceAuthenticationPassword: string;
    deviceAuthenticationAllowed: boolean;
    deviceAccounts: DeviceAccount[];

    samlLoginUrl: string;
    logoutUrl: string;
};

const REDIRECT_PARAM = 'rd';

export type DeviceAccount = {
    email: string;
    name: string;
};

export function useAuthenticationContext(): AuthenticationContext {
    const redirect = useViewArg<string | null>(REDIRECT_PARAM);
    const redirectConfirmation = useViewArg<boolean>('redirect_confirmation');

    const authenticated = useViewArg<boolean>('authenticated');
    const deviceAuthenticationAllowed = useViewArg<boolean>(
        'device_authentication_allowed',
    );
    const deviceAuthenticationEnabled = useViewArg<boolean>(
        'device_authentication_enabled',
    );
    const deviceAuthenticationPassword = useViewArg<string>(
        'device_authentication_password',
    );
    const deviceAccounts = useViewArg<DeviceAccount[]>('device_accounts');

    const samlLoginUrl = useViewArg<string>('saml_login_url');
    const logoutUrl = useViewArg<string>('logout_url');

    return {
        redirect,
        redirectConfirmation,
        authenticated,
        deviceAuthenticationEnabled,
        deviceAuthenticationPassword,
        deviceAuthenticationAllowed,
        deviceAccounts,
        samlLoginUrl,
        logoutUrl,
    };
}
